import api from '@/libs/axiosInstance';
import { tokenManager, type AuthTokens } from '@/libs/token-manager';
import type { ApiResponse } from '@fluenceur/types';
import { useMutation } from '@tanstack/react-query';
import { resetProductAnalytics } from '@/libs/product-analytics';

interface ResetPasswordParams {
  token: string;
  password: string;
  passwordConfirmation: string;
}

interface ResetPasswordResponse extends ApiResponse {
  data: AuthTokens;
}

const resetPasswordRequest = async (params: ResetPasswordParams): Promise<AuthTokens> => {
  const response = await api.post<ResetPasswordResponse>('/auth/password-reset/confirm', {
    token: params.token,
    password: params.password,
    passwordConfirmation: params.passwordConfirmation,
  });

  if (response.data?.success !== true) {
    throw new Error(response.data?.message || 'Failed to reset password');
  }

  // Extract tokens from response
  const tokens = response.data.data;

  // Store tokens in token manager (same as login)
  resetProductAnalytics();
  tokenManager.setTokens(tokens);

  console.log('[PASSWORD-RESET] Password reset successful, tokens stored');

  return tokens;
};

export const useResetPasswordAction = () =>
  useMutation<AuthTokens, Error, ResetPasswordParams>({
    mutationFn: resetPasswordRequest,
  });
